import { Link } from 'react-router-dom'
import './Thumb.scss'
import { useContext } from 'react'
import { ThemeContext } from '../../context'

export default function Thumb(props)
{
    const {theme} = useContext(ThemeContext)

    const id=props.ID
    return(
        <Link to={`/Card/${id}`} className={`thumb , thumbTheme_${theme}`}>
            <img src={process.env.PUBLIC_URL + '/Photos/Miniatures/' + props.SPECIMEN + '.jpg'} alt={props.SPECIMEN} />
            
            <h2>{props.ESPECE}</h2>
            <span className='auteur'>{props.AUTEUR}</span>
            <p>ID : {props.SPECIMEN}<br/>
            {props.ORIGINE}<br/>
            {props.REGION}</p>
            <p>{props.SOUS_ETAGE}</p>
        </Link>
    )
}